import styles from "./logo.module.css";
import React from "react";
import { getTodaysDoodle } from "../../data/doodles";

const COLORS = ["blue", "red", "yellow", "blue", "green", "red"];
const TEXT = "Shukurov";

const Logo = () => {
  const doodle = getTodaysDoodle();

  return (
    <div className={styles.searchLogo}>
      <div className="logo-text">
        {[...TEXT].map((ch, i) =>
          ch === " " ? (
            <span key={i} className={styles.logoGap} />
          ) : (
            <span
              key={i}
              className={`${styles.logoLetter} ${styles[COLORS[i % COLORS.length]]}`}
              style={{ "--i": i } as React.CSSProperties}
            >
              {ch}
            </span>
          )
        )}
        {doodle && (
          <span className={styles.doodle} title={doodle.label} data-animation={doodle.animation}>
            {doodle.emoji}
          </span>
        )}
      </div>
    </div>
  );
};

export default Logo;
